document.addEventListener("DOMContentLoaded", () => {
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        });
    });


    // Search functionality for designers
    const searchInput = document.querySelector('.search-designers');
    const brandSections = document.querySelectorAll('.all-brands__section');
    const containerBrands = document.querySelector('.all-brands__brands');

    if (searchInput && brandSections.length > 0) {
        searchInput.addEventListener('input', function (event) {
            const searchText = event.target.value.toLowerCase();

            if (searchText === '') {
                brandSections.forEach((section) => {
                    section.classList.remove('active', 'width-100');
                    const allBrandElements = section.querySelectorAll('.all-brands__brand');
                    allBrandElements.forEach(brandEl => {
                        brandEl.classList.remove('active');
                    });
                });
                containerBrands.classList.remove("active");

                return;
            }

            brandSections.forEach((section) => {
                if (!section) return;

                const brands = section.querySelectorAll('.all-brands__brand');

                if (brands.length === 0) return;

                let sectionHasExactMatch = false;

                brands.forEach((brandEl) => {
                    if (!brandEl) return;

                    const brand = brandEl.querySelector('a');
                    if (!brand) return;

                    const brandText = brand.textContent.trim().toLowerCase();

                    if (brandText.startsWith(searchText)) {
                        sectionHasExactMatch = true;
                    }
                });

                if (sectionHasExactMatch) {
                    section.classList.remove('active');
                    section.classList.add('width-100');
                    containerBrands.classList.add("active");

                    brands.forEach((brandEl) => {
                        const brand = brandEl.querySelector('a');
                        if (!brand) return;

                        const brandText = brand.textContent.trim().toLowerCase();
                        brandEl.classList.toggle('active', !brandText.startsWith(searchText));
                    });
                } else {
                    section.classList.remove('width-100');
                    section.classList.add('active');

                    // Rimuovi la classe active da tutti i brand
                    brands.forEach((brandEl) => {
                        brandEl.classList.remove('active');
                    });
                }
            });
        });
    }



    // Show more button functionality
    const showMoreButton = document.querySelector(".show-more-button");
    const letters = document.querySelectorAll(".all-brands__letter");
    const containerLetter = document.querySelector(".all-brands__letters");


    if (letters.length > 6) {
        showMoreButton.classList.remove("hidden");
    } else {
        showMoreButton.classList.add("hidden");
    }

    if (showMoreButton) {
        showMoreButton.addEventListener("click", function () {
            letters.forEach(letter => {
                letter.style.display = "inline-block"; // Show all letters
            });

            showMoreButton.classList.add("hidden"); // Hide button
            containerLetter.classList.add("active");
        });
    }
});
